import { Injectable } from '@angular/core';

import { AppIcon, AppIconName, RawSVG } from './icon.type';

@Injectable({ providedIn: 'root' })
export class AppIconsLibrary {
  private icons = new Map<AppIconName, RawSVG>();

  addIcon(icon: RawSVG, name: AppIconName): void {
    this.icons.set(
      name,
      icon
        .replace('<svg', '<svg class="svg-icon" ')
        .replace(/data-fill/g, 'fill')
        .replace(/data-stroke/g, 'stroke') as RawSVG,
    );
  }

  getIcon(name: AppIconName): AppIcon | undefined {
    const icon = this.icons.get(name);
    if (!icon) {
      console.warn(`${name} icon was not found`);
      return undefined;
    }
    return { svgData: icon, name };
  }
}
